import(/* webpackMode: "eager" */ "/codebuild/output/src2561965530/src/rev-pay-landing/src/app/(auth)/forgot-password/page.tsx");
